import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "tatenda_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const fileUrl = (urlPath) => {
  if (!urlPath) return "";
  if (/^https?:\/\//i.test(urlPath)) return urlPath;
  return `${process.env.REACT_APP_BACKEND_URL}${urlPath}`;
};

// Public
export const fetchContent = async () => (await axios.get(`${API}/content`)).data;
export const fetchProjects = async () => (await axios.get(`${API}/projects`)).data;
export const sendContact = async (form) => (await axios.post(`${API}/contact`, form)).data;

// Auth
export const login = async (password) => {
  const res = await axios.post(`${API}/admin/login`, { password });
  setToken(res.data.token);
  return res.data.token;
};
export const logout = () => clearToken();
export const verifyToken = async () => {
  if (!getToken()) return false;
  try {
    await axios.get(`${API}/admin/me`, { headers: authHeaders() });
    return true;
  } catch {
    clearToken();
    return false;
  }
};

// Admin content + projects
export const updateContent = async (content) =>
  (await axios.put(`${API}/admin/content`, content, { headers: authHeaders() })).data;

export const createProject = async (project) =>
  (await axios.post(`${API}/admin/projects`, project, { headers: authHeaders() })).data;

export const updateProject = async (id, project) =>
  (await axios.put(`${API}/admin/projects/${id}`, project, { headers: authHeaders() })).data;

export const deleteProject = async (id) =>
  (await axios.delete(`${API}/admin/projects/${id}`, { headers: authHeaders() })).data;

export const uploadFile = async (file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await axios.post(`${API}/admin/upload`, fd, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return res.data; // { url, filename, size }
};

export const deleteUpload = async (url) =>
  (await axios.delete(`${API}/admin/upload`, { params: { url }, headers: authHeaders() })).data;

export const listMessages = async () =>
  (await axios.get(`${API}/contact`, { headers: authHeaders() })).data;
